<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen scrollable max-width="100%" height="100px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" class="view-docs-btn">{{isRestricted?'View Restricted Docs':'View Docs'}}</v-btn>
      </template>
      <v-card v-if="dialog">
        <v-card-title fixed class="document-header">
          <span class="headline">Documents for Record #{{order.doc_id}} | {{order.doc_type}}</span>
          <i class="mdi mdi-close close-btn"  @click="dialog = false" :disabled="loading"></i>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear
          v-if="loading"
          indeterminate
        ></v-progress-linear>
        <v-row>
            <v-col
                cols="12"
                sm="12"
                class="scroll-y"
                style="max-height: 800px; min-height: 550px; overflow: auto;padding: 0.2rem;border: solid 7px #636060;background: #636060;"
            >
                <pdfJSViewer v-if="order.package" :pdfURL="order.package.file" :allowSelection="!isRestricted" ref="pdfViewerWrapper" :existingSelections="existingSelections" :reasonOptions="reasonOptions" :handleSaveSelections="handleSaveSelections" :currentSelections="currentSelections"> </pdfJSViewer>
                <v-btn @click="download_dt_doc(order)" color="primary" v-if="!order.package" dark :disabled="isDownloading">{{isDownloading? 'Downloading...': 'Download Document'}}</v-btn>
            </v-col>
        </v-row>
        <!--<div>
            <v-container fluid>
                <v-layout row wrap>
                <v-flex xs12>
                    <v-flex xs3>Test</v-flex>
                    <v-flex xs7>
                        <pdfJSViewer :pdfURL="pdfURL"> </pdfJSViewer>
                    </v-flex>
                </v-flex>
                </v-layout>
            </v-container>
        </div>-->
        <v-divider></v-divider>
        <v-card-actions fixed class="actions-container">
          <v-btn color="primary" dark @click="handleSaveSelections" :disabled="loading">{{loading? 'Saving...': 'Save'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { DOWNLOADDTDOC, GETDOCUMENTSELECTIONS, ADDDOCUMENTSELECTIONS } from '@/store/actions.type'
import pdfJSViewer from '@/components/pdfViewerJS.vue'
import { DOCUMENT_SELECTION_EVENTS } from '@/components/pdf/utils/constants'
import { convertBase64ToFile } from '@/components/pdf/utils/helpers'

const { getValidSelections } = DOCUMENT_SELECTION_EVENTS
export default {
  name: 'runSheetDoc',
  components: {
    pdfJSViewer
  },
  data: () => ({
    dialog: false,
    note: null,
    loading: false,
    existingSelections: [],
    currentSelections: [],
    isDownloading: false,
    isRestricted: false
  }),
  props: {
    order: null,
    type: null,
    reasonOptions: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler (newVal, oldVal) {
        this.getExistingSelections()
        const order = this.order
        if (this.dialog && order && !order.package) {
          this.download_dt_doc(this.order)
        }
      }
    },
    order: {
      immediate: true,
      handler (newVal) {
        if (newVal && newVal.package) {
          this.isRestricted = newVal.package.is_restricted
        }
      }
    }
  },
  methods: {
    download_dt_doc (data) {
      let runsheetPayload = {
        run_sheet_id: this.order.id
      }
      this.loading = true
      this.isDownloading = true
      this.$store.dispatch(DOWNLOADDTDOC, runsheetPayload).then(runsheetResponse => {
        this.order = runsheetResponse
        this.$emit('docUpdated', runsheetResponse)
      }).finally(() => {
        this.isDownloading = false
        this.loading = false
      })
    },
    handleSaveSelections () {
      return new Promise((resolve) => {
        this.$refs.pdfViewerWrapper.$emit(getValidSelections, (data, codeToSelect) => {
          let updatedSelections = []
          if (data && data.length > 0) {
            updatedSelections = data.map(rect => {
              return {
                ...rect,
                order_run_sheet: this.order.id
              }
            })
          }
          this.addExistingSelections(updatedSelections, codeToSelect).finally(() => {
            resolve()
          })
        })
      })
    },
    getExistingSelections () {
      if (this.order.id && this.dialog) {
        this.$store.dispatch(GETDOCUMENTSELECTIONS, { order_run_sheet_id: this.order.id }).then(response => {
          this.existingSelections = response
        })
      }
    },
    addExistingSelections (selectionsData, codeToSelect) {
      return new Promise((resolve) => {
        const formData = new FormData()
        formData.append('order_run_sheet_id', this.order.id)
        selectionsData.forEach((sel, index) => {
          const keys = {
            ...sel,
            selection_screenshot: convertBase64ToFile(sel.selection_screenshot)
          }

          for (const [key, value] of Object.entries(keys)) {
            formData.append(`run_sheet_selections[${index}]${key}`, value)
          }
        })

        if (codeToSelect) {
          formData.append('piq', codeToSelect)
        }
        this.loading = true
        this.$store.dispatch(ADDDOCUMENTSELECTIONS, formData).then(response => {
          this.dialog = false
          this.$emit('selections-updated')
        }).finally(() => {
          this.loading = false
          resolve()
        })
      })
    }
  }
}
</script>
<style scoped>
.document-header{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.close-btn{
  font-size: 24px;
  padding-inline: 5px;
  border-radius: 50%;
}
.close-btn:hover{
  cursor: pointer;
  background: rgb(var(--secondary-color));
}
.actions-container{
  display: flex;
  justify-content: center;
}

.view-docs-btn{
  height: 30px !important;
  padding: 0 12px !important;
  font-size: 12px;
  border-radius: 4px;
}
</style>
